export default "__VITE_ASSET__DXOfvAGY__"